export default "__VITE_ASSET__B2WGVSqX__"